function FileLayout({ children }) {
    return (
        <div className="overflow-hidden min-h-screen">
            <header
                className="sticky top-0 z-50 flex w-full h-20 from-primary from-30% to-black border-b border-sky-100 border-opacity-30"
                style={{ backgroundImage: 'linear-gradient(45deg, var(--tw-gradient-stops))' }}
            >
                <div className="flex justify-center w-full p-3">
                    <img src={`/assets/img/rometal-logo.png`} alt="Logo" className="block max-w-60" />
                </div>
            </header>

            <div
                className="App before:content-[''] before:absolute before:inset-0 before:bg-tertiary before:opacity-10 before:-z-[1] from-primary from-30% to-black min-h-[calc(100vh_-_5rem)]"
                style={{ backgroundImage: 'linear-gradient(10deg, var(--tw-gradient-stops))' }}
            >
                <div className="container max-w-large">{children}</div>
            </div>
        </div>
    );
}

export default FileLayout;
